import { Session } from '@benzinga/session';
import { Subscribable } from '@benzinga/subscribable';
import { WatchlistId } from '@benzinga/watchlist-manager';
import { WatchlistHoldingsFeed, WatchlistHoldingsFeedEvent } from './feed';
import { WatchlistHoldingsStore } from './store';

export type WatchlistHoldingsManagerEvent = WatchlistHoldingsFeedEvent;

export class WatchlistHoldingsManager extends Subscribable<WatchlistHoldingsManagerEvent> {
  private session: Session;
  private store: WatchlistHoldingsStore;

  constructor(session: Session) {
    super();
    this.session = session;
    this.store = new WatchlistHoldingsStore();
  }

  public static getName = () => 'benzinga-watchlist-holdings';
  public static getEnvironment = (_env: Record<string, string>) => ({});

  public createWatchlistFeed = (
    watchlistId: WatchlistId,
    subscribeToQuotes: boolean,
    visibleSymbols?: string[],
  ): WatchlistHoldingsFeed => {
    // Create a new feed instance for each call to support multiple widget instances
    return new WatchlistHoldingsFeed(watchlistId, subscribeToQuotes, this.session, visibleSymbols);
  };
}
